import { useAsync } from 'react-use'
import { fetchEvent } from '@/services/client.service'
import NoteCard, { NoteCardLoadingSkeleton } from './NoteCard'

export default function PinnedNoteCard({
  eventId,
  className
}: {
  eventId: string
  className?: string
}) {
  const { value: event, loading: isFetching } = useAsync(() => fetchEvent(eventId), [eventId])

  if (isFetching) {
    return <NoteCardLoadingSkeleton />
  }

  if (!event) {
    return null
  }

  return <NoteCard event={event} className={className} pinned />
}
